module.exports = __webpack_public_path__ + "static/media/icon-word.2d2eafa1.png";